import axios from "axios";
import { config } from '../../config/Config';

export const getUserGameRegistries = async (obj) => {
    try {
        const response = await axios({
            method: 'get',
            url: `${config.serverBaseUrl}/v1/web/user-game`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${obj.accessToken}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching user game registries:', error.response?.data || error.message);
        throw error;
    }
};

export const getUserGameRegistriesByOrgId = async (obj) => {
    try {
        const response = await axios({
            method: 'get',
            url: `${config.serverBaseUrl}/v1/web/user-game/org/${obj.orgId}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${obj.accessToken}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching org user game registries:', error.response?.data || error.message);
        throw error;
    }
};

export const getUserGameRegistryByUserId = async (obj) => {
    try {
        const response = await axios({
            method: 'get',
            url: `${config.serverBaseUrl}/v1/web/user-game/user/${obj.userId}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${obj.accessToken}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching user game registry:', error.response?.data || error.message);
        throw error;
    }
};

/**
 * Suspend / reactivate / archive a user's access at a scope by setting only their membership
 * state (roles preserved). `obj.data` = { userId, orgId, gameId?, state }.
 * The deepest id present selects the scope (client → game → org).
 */
export const setUserGameState = async (obj) => {
    try {
        const response = await axios({
            method: 'put',
            url: `${config.serverBaseUrl}/v1/web/user-game/as-owner/state`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${obj.accessToken}`
            },
            data: obj.data
        });
        return response.data;
    } catch (error) {
        console.error('Error setting user game state:', error.response?.data || error.message);
        throw error;
    }
};